import React from 'react'
import { theme } from 'antd'
import AgiliteSkeleton from '../../../reusable-components/AgiliteSkeleton'
import { useViewingRecord } from './hooks/useViewingRecord'
import { updateBooking } from '../../../Bookings/utils/utils'
import { Header, BookingSummary, MedicalAid, RescheduleCard, ActionsCard, MetaHealthLogo } from './components'

const ViewingRecord = ({ data, setData, setModalOpen, refreshFunction, medicalProfessionals }) => {
  const { token } = theme.useToken()

  const {
    loading,
    setLoading,
    recordData,
    reassigning,
    rescheduling,
    setRescheduling,
    rescheduleDate,
    setRescheduleDate,
    rescheduleTime,
    setRescheduleTime,
    updatingBooking,
    authState,
    dispatch,
    onAfterCancel,
    onSuccess,
    onFail,
    handleReassignment,
    handleReschedule,
    resetRescheduleData
  } = useViewingRecord(data, refreshFunction)

  const handleReassignmentWithMedProfs = (value, target) => {
    handleReassignment(value, target, medicalProfessionals)
  }

  if (recordData) {
    return (
      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
          backgroundColor: '#fafafa',
          border: '4px solid #1890ff',
          borderRadius: '12px',
          overflow: 'hidden'
        }}
      >
        <Header recordData={recordData} setData={setData} token={token} />

        {loading ? (
          <div style={{ padding: '40px' }}>
            <AgiliteSkeleton skActive spinnerTip='' />
          </div>
        ) : (
          <div style={{ padding: '24px', display: 'flex', gap: '24px' }}>
            {/* Left Column */}
            <div style={{ flex: 2 }}>
              <BookingSummary
                recordData={recordData}
                rescheduling={rescheduling}
                reassigning={reassigning}
                handleReassignment={handleReassignmentWithMedProfs}
                medicalProfessionals={medicalProfessionals}
                token={token}
              />

              {!rescheduling && <MedicalAid recordData={recordData} token={token} />}

              {rescheduling && (
                <RescheduleCard
                  rescheduleDate={rescheduleDate}
                  setRescheduleDate={setRescheduleDate}
                  rescheduleTime={rescheduleTime}
                  setRescheduleTime={setRescheduleTime}
                  token={token}
                />
              )}
            </div>

            {/* Right Column - Actions */}
            <div style={{ flex: 1, minWidth: '280px' }}>
              <ActionsCard
                rescheduling={rescheduling}
                setRescheduling={setRescheduling}
                updatingBooking={updatingBooking}
                rescheduleDate={rescheduleDate}
                rescheduleTime={rescheduleTime}
                handleReschedule={handleReschedule}
                resetRescheduleData={resetRescheduleData}
                recordData={recordData}
                setLoading={setLoading}
                dispatch={dispatch}
                onFail={onFail}
                onSuccess={onSuccess}
                data={data}
                authState={authState}
                updateBooking={updateBooking}
                onAfterCancel={onAfterCancel}
                token={token}
              />

              <MetaHealthLogo />
            </div>
          </div>
        )}
      </div>
    )
  } else {
    return <></>
  }
}

export default ViewingRecord
